export default {
      id: "icon-reply_transfer-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-reply_transfer",
      toString: function () {
        return this.url;
      }
    }